export default {
  id: undefined,
  type: 'service',
  attributes: {
    name: 'New Service',
    company_id: null,
  },
}
